Revolution.Module.extend({
    NAME: "mde.main", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        //_.bindAll(this, "myfunction", "runEqualHeight", "getHeightsForOffsets");

        //Example to call an external function
        //var UTILS = Revolution.get("mde._utils");
        //UTILS.equalheight($('.bk-mosaique .js-equal-height'));

        //prevent pace.js loading bug
        setTimeout(function () {
            $('body').removeClass('pace-running').addClass('pace-done');
        }, 2000);

        // IF IE : set width for logo
        if ((window.navigator.userAgent.indexOf("MSIE ")> 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))) {
            this.setSizeLogoHeaderForIE();
        }
        this.setSizeLogoFooter();
        this.setSizeLogoPartners();

        // Object-fit pollyfill
        objectFitImages();

        this.setScrollToTopVisibility();
        $('.btn-back-to-top').click(this.goToTopPage);

        this.addPaddingRightLikeSitecontent();
        this.addPaddingLeftLikeSitecontent();
        // this.widthTextBlockImageText();

        this.initTooltip();

        // pour savoir si on est en train de scroller ou non
        this.timerScroll = null;

        // tarteaucitron
        $('body').on('click', '#tarteaucitronAlertSmall', function() {
            $('#tarteaucitronManager').click();
        });

        this.titleWidth();

        $('.bk-before-after input[type="range"]').on('input change',this.beforeAfter);

        $('.paragraph--type--image, .paragraph--type--text-image').on('media-images').each(function () {
          var mediaInfo = $(this).find('.media-infos');

          // Remove tooltip for image, in case media not hide it.
          if (!mediaInfo.hasClass('hidden')) {
            $(this).find('img').removeAttr('title');
          }
        });

      },

      onWindowLoad: function (e) {
        this.addPaddingRightLikeSitecontent();
        this.addPaddingLeftLikeSitecontent();
        this.setElemW($(this));

      },
      onWindowScroll: function (e) {
        clearTimeout(this.timerScroll);
        this.setScrollToTopVisibility();
        this.checkScrollStop();
      },
      onWindowResize: function (e) {
        this.setScrollToTopVisibility();
        this.addPaddingRightLikeSitecontent();
        this.addPaddingLeftLikeSitecontent();
        this.setElemW($(this));
        // this.widthTextBlockImageText();
    },

    setElemW : function() {
        $('.js-fit-to-right-border').each(function() {

            $(this).css('marginRight', '');

            var $offsetL = $(this).offset().left + $('body').scrollLeft();
            var $offsetR = $offsetL + parseFloat($(this).css('width').replace("px", ""));
            var $windowW = parseFloat($('body').css('width').replace("px", ""));
            var $availableW = $windowW - $offsetR;

            // console.log($offsetL, '//', $offsetR, '//', $windowW, '//' , $availableW);

            $(this).css('marginRight', '-' + $availableW + 'px');
        });
    },

    goToTopPage: function () {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
        Revolution.get("mde.accessible-function").giveTempFocus($('body'));
    },

    setScrollToTopVisibility: function (e) {
        var $btn = $('.btn-back-to-top');
        var offset = $(window).height();

        if ($(window).scrollTop() > offset) {
            $btn.addClass('visible');
        } else {
            $btn.removeClass('visible');
        }
    },

    addPaddingRightLikeSitecontent: function (e) {
        $('.js-add-padding-right').each(function (index, elem) {
            var padding = (window.innerWidth - $(elem).closest('.site-content').width()) / 2;
            $(elem).css('padding-right', padding + 'px');
            $(elem).css('padding-left', '0px');

            if (window.innerWidth < 1024) {
                $(elem).css('padding-left', padding + 'px');
            }

            if ($(elem).find('.text-infos').length) {
                if (window.innerWidth >= 1024) {
                    setTimeout(function () {
                        $(elem).find('.img-wrapper').css('width', window.innerWidth - padding - $(elem).find('.text-infos').outerWidth(true));
                        $(elem).find('img').attr('width', window.innerWidth - padding - $(elem).find('.text-infos').outerWidth(true));
                    }, 500);
                } else {
                    $(elem).find('.img-wrapper').css('width', 'auto');
                    $(elem).find('img').removeAttr('width');
                }
            }
        });
    },

    addPaddingLeftLikeSitecontent: function (e) {
        $('.js-add-padding-left').each(function (index, elem) {
            var padding = (window.innerWidth - $(elem).closest('.site-content').width()) / 2;
            $(elem).css('padding-left', padding + 'px');
            $(elem).css('padding-right', '0px');

            if (window.innerWidth < 1024) {
                $(elem).css('padding-right', padding + 'px');
            }

            if ($(elem).find('.text-infos').length) {
                if (window.innerWidth >= 1024) {
                    var widthForImage = $('body').width() - (($('body').width() - $(elem).closest('.site-content').width()) / 2) - $(elem).find('.text-infos').outerWidth(true);
                    setTimeout(function () {
                        $(elem).find('.img-wrapper').css('width', widthForImage);
                        $(elem).find('img').attr('width', widthForImage);
                    }, 500);
                } else {
                    $(elem).find('.img-wrapper').css('width', 'auto');
                    $(elem).find('img').removeAttr('width');
                }
            }
        });
    },

    // widthTextBlockImageText: function () {
    //     $('.bk-img-text').each(function (index, elem) {
    //         var $textInfos = $(elem).find('.text-infos');
    //         var width = $textInfos.closest('.site-content').width() * 0.7;

    //         if ($(elem).css('display') == 'flex') {
    //             $textInfos.css('width', width + 'px');

    //             var widthLegend = $textInfos.offset().left - $(elem).closest('.site-content').offset().left - parseInt($(elem).closest('.site-content').css('padding-left'));
    //             console.log(widthLegend);

    //             if ($(elem).closest('.-reverse').length) {
    //                 widthLegend = $(elem).closest('.site-content').offset().left + $(elem).closest('.site-content').width() + parseInt($(elem).closest('.site-content').css('padding-left')) - $(elem).find('.img-wrapper').offset().left;
    //             }

    //             $(elem).find('.media-infos').css('max-width', widthLegend + 'px');
    //         } else {
    //             $textInfos.removeAttr('style');
    //             $(elem).find('.media-infos').removeAttr('style');
    //         }
    //     });
    // },

    initTooltip: function (e) {
        if ($('.js-bk-tooltip').length) {
            $('.js-bk-tooltip').each(function (index, elem) {
                $(elem).find('.js-simple-tooltip').accessibleSimpleTooltipAria({
                    simpletooltipText: $(elem).find('.js-tooltip-content').html()
                });
            })
        }
    },

    checkScrollStop: function (e) {
        // quand le scroll est terminé depuis 3 secondes, retire btn-back-to-top
        var $btn = $('.btn-back-to-top');

        if (this.timerScroll !== null) {
            clearTimeout(this.timerScroll);
        }
        this.timerScroll = setTimeout(function () {
            $btn.removeClass('visible');
        }, 3000);
    },

    setSizeLogoHeaderForIE: function (e) {
        // Header
        var heightLogo = $('.header-logo').find('img').attr('height');
        var urlLogo = window.location.origin + $('.header-logo').find('img').attr('src');

        jQuery.ajax({
            url: urlLogo,
            method: 'GET',
            dataType: "xml",
            async: true
        })
        .done(function(data) {
            var svgViewBox = $(data).find('svg').attr('viewBox');
            var widthXml = svgViewBox.split(" ")[2];
            var heightXml = svgViewBox.split(" ")[3];

            $('.header-logo').find('img').attr('width', Math.round((heightLogo * widthXml) / heightXml));
            $('.header-logo').find('a').css('width', Math.round((heightLogo * widthXml) / heightXml)+'px');
        })
    },

    setSizeLogoPartners: function (e) {
        // footer
        $('.partners-logos img').each(function (index, elem) {
            $(elem).attr('width', parseInt($(elem).css('width')) ? parseInt($(elem).css('width')) : 'auto');
        })

        // Inside edito
        $('.bk-logo-partner').each(function (index, elem) {
            $(elem).find('img').attr('width', $(elem).width());
        })
    },

    setSizeLogoFooter: function (e) {
        // Footer
        var heightLogoFooter = $('.page-footer-wrapper .main-logo').find('img').attr('height');
        var urlLogoFooter = window.location.origin + $('.page-footer-wrapper .main-logo').find('img').attr('src');

        jQuery.ajax({
            url: urlLogoFooter,
            method: 'GET',
            dataType: "xml",
            async: true
        })
        .done(function(data) {
            var svgViewBox = $(data).find('svg').attr('viewBox');
            var widthXml = svgViewBox.split(" ")[2];
            var heightXml = svgViewBox.split(" ")[3];

            $('.page-footer-wrapper .main-logo').find('img').attr('width', Math.round((heightLogoFooter * widthXml) / heightXml));
            $('.page-footer-wrapper .main-logo').css('width', Math.round((heightLogoFooter * widthXml) / heightXml)+'px');
        })
    },

    titleWidth : function() {
        $('.page-content-wrapper h2').each(function(index, el) {
            if($(el).next('.paragraph--type--video').length || $(el).next('.paragraph--type--podcast').length) {
                $(el).addClass('js-width');
            }
        });
    },

    beforeAfter : function(e) {
        var $obj = $(e.currentTarget);
        var value = $obj.val();
        // console.log(value);

        $('.bk-before-after .after').width(value*10+'%');
        $('.bk-before-after .wrapper-range').css('right', value*10+'%');
    }
});
